import { GetterTree } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'

const getters: GetterTree<FeatureFlagsState, IRootState> = {
  isBlackFridayActive: state => {
    return state?.blackFridayEnabled ?? false
  },
  isCyberMondayActive: state => {
    return state?.cyberMondayEnabled ?? false
  },
  isTCSPromoEnabled: state => {
    return state?.tcsPromoEnabled ?? false
  },
  isFlashSaleActive: state => {
    return state?.flashSaleEnabled ?? false
  },
  showB2BBanner: state => {
    return state?.showB2BBanner ?? false
  },
  premiumPlusEnabled: state => {
    return state?.premiumPlusEnabled ?? false
  },
  isSpringPromoEnabled: state => {
    return state?.springPromoEnabled ?? false
  },
  isMaySaleEnabled: state => {
    return state?.maySaleEnabled ?? false
  },
  isMayFlashSaleEnabled: state => {
    return state?.mayFlashSaleEnabled ?? false
  },
}

export default getters
